<template>
  <!-- CPAP 処方変更・中止等申込み -->
  <div id="CpapPatientList">
    <section>
      <div :id="getContainerType()">
        <div v-if="isEscrow" class="labelTitle lable">CPAP 預託機処方変更・再開申込み</div>
        <div v-else-if="temp" class="labelTitle lable">CPAP処方変更・中止等申込み（仮持出品使用）</div> <!-- QA68 20231227 -->
        <div v-else class="labelTitle lable">CPAP 処方変更・中止等申込み</div> <!-- QA68 20231227 -->
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <template v-if="(isHospital||isDealer)"><!-- 外部ユーザー-->
              <tr>
                <th>診察券ID</th>
                <td><input type="text" v-model="searchConditions.patientRegistrationCard"/></td>              
                <th>患者名</th>
                <td><input type="text" v-model="searchConditions.patientName"/></td>
                <th>患者名<br/>(カナ)</th>
                <td><input type="text" v-model="searchConditions.patientNameKana"/></td>
                <th>状態</th>
                <td><select v-model="searchConditions.progress">
                  <option value=""></option>
                  <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
                </td>
              </tr>
              <tr>
                <th>担当支店</th>
                <td>
                  <select v-model="searchConditions.salesOfficeCode">
                    <option value=""></option>
                    <option v-for="item in branchList" :key="item.code" :value="item.code">{{item.name}}</option>
                  </select>
                </td>
                <th v-if="isHospital">医療機関<br/>コード</th>
                <td v-if="isHospital"><input type="text" v-model="searchConditions.medicalInstitutionCode"/></td>
                <th>医療<br/>機関名</th>
                <td><input type="text" v-model="searchConditions.medicalInstitutionName"/></td>
                <th>シリアル</th>
                <td><input type="text" v-model="searchConditions.serial"/></td>
              </tr>
            </template>
            <template v-else> <!--内部ユーザー-->
              <tr>
                <th>診察券ID</th>
                <td><input type="text" v-model="searchConditions.patientRegistrationCard"/></td>              
                <th>患者<br/>コード</th>
                <td><input type="text" v-model="searchConditions.patientCode"/></td>
                <th>患者名</th>
                <td><input type="text" v-model="searchConditions.patientName"/></td>
                <th>患者名<br/>(カナ)</th>
                <td><input type="text" v-model="searchConditions.patientNameKana"/></td>
              </tr>
              <tr>
                <th>担当支店</th>
                <td>
                  <select v-model="searchConditions.salesOfficeCode">
                    <option value=""></option>
                    <option v-for="item in branchList" :key="item.code" :value="item.code">{{item.name}}</option>
                  </select>
                </td>
                <th>医療機関<br/>コード</th>
                <td><input type="text" v-model="searchConditions.medicalInstitutionCode"/></td>
                <th>医療<br/>機関名</th>
                <td><input type="text" v-model="searchConditions.medicalInstitutionName"/></td>
                <th>シリアル</th>
                <td><input type="text" v-model="searchConditions.serial"/></td>
              </tr>
              <tr>
                <th>指示日</th>
                <td colspan="3">
                    <input type="date" style="width:230px" v-model="searchConditions.instructionDateStart"/>
                 ～ <input type="date" style="width:230px" v-model="searchConditions.instructionDateEnd"/></td>
                <th>転院期間</th>
                <td colspan="3">
                    <input type="month" style="width:230px" v-model="searchConditions.transferPeriodStart"/>
                ～ <input type="month" style="width:230px" v-model="searchConditions.transferPeriodEnd"/></td>
              </tr>
              <tr>
                <th>状態</th>
                <td>
                  <select v-model="searchConditions.progress">
                    <option value=""></option>
                    <option v-for="item in progressList" :key="item.code" :value="item.code">{{item.name}}</option>
                  </select>
                </td>
              </tr>
            </template>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
          <div v-if="(isHospital || isDealer) && !temp" style="color:black">
            転院先確定済の患者さんはこちらの画面では確認できません。<router-link :to="{name:'CpapRequestList'}"><a style="font-weight: bold;color:blue">CPAP処方申込履歴画面</a></router-link>からご確認ください。
          </div>
          <div v-else-if="!(isHospital || isDealer) && !temp" style="color:black">
            転院先確定済の患者さんはこちらの画面では確認できません。<router-link :to="{name:'CpapRequestSearch'}"><a style="font-weight: bold;color:blue">CPAP 案件検索画面</a></router-link>からご確認ください。
          </div>
          <div v-if="isEscrow" style="color:black">
            転入予定の患者さんの受け入れ処理は、<a href="#" style="font-weight: bold;color:blue" @click="isEscrowDeletion">こちら</a>からお願いします。
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area"  v-if="data.length > 0">
          <div>
            <span class="result-count">件数：{{data.length}}件</span>
            <b-table
              id="requestFormListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="patientCode"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column v-if="isHospital || isDealer" field="patientRegistrationCard" label="診察券ID" width="100" centered sortable>
                  <router-link :to="{name:'CpapPatientDetail', params:{targetId:props.row.id, searchConditions:searchConditions, isEscrow, progress:props.row.progress}}"><a>{{props.row.patientRegistrationCard}}</a></router-link>
                </b-table-column>
                <b-table-column v-else field="patientCode" label="患者コード" width="100" centered sortable>
                  <router-link :to="{name:'CpapAgentPatientDetail', params:{targetId:props.row.id, searchConditions:searchConditions, temp:temp, isEscrow}}"><a>{{props.row.patientCode}}</a></router-link>
                </b-table-column>
                <b-table-column field="patientName" label="患者名" width="100" sortable>{{props.row.patientName}}</b-table-column>
                <b-table-column field="phoneNumber" label="電話番号" width="180" sortable>{{props.row.phoneNumber}}</b-table-column>
                <b-table-column field="model" label="機器" width="180" sortable>{{props.row.reportFormatType | getNameFilter(modelList)}}</b-table-column>
                <b-table-column field="serial" label="シリアル" width="180" sortable>{{props.row.serial}}</b-table-column>
                <b-table-column field="branchOfficeCode" label="支店" width="180" sortable >{{props.row.branchOfficeCode | codeFilter(branchList)}}</b-table-column>
                <b-table-column field="progress" label="状態" width="180" sortable centered>
                  <span :class="getCpapPatientStatusClass(props.row.progress)">
                    {{ progressCodeFilter(props.row)}}
                  </span>
                </b-table-column>
              </template>
            </b-table>
          </div>
          <div>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <div class="result-area" v-if="dataBlank && data.length == 0">
          <div class="result-count">件数：{{data.length}}件</div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";

export default {
  name: "CpapPatientList",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    back: function() {
      if(this.temp){
        // 仮持出メニュー
        this.$router.push({name: "cpapTempInstalledHome"});
      }else if(this.isEscrow){
        // 預託メニュー
        if(this.isHospital || this.isDealer){
          // 外部ユーザー
          this.$router.push({name: "CpapRequestMenu"});
        }else{
          // 内部ユーザー
          this.$router.push({name: "CpapRequestHome"});
        }
      }else{
        if(this.isHospital || this.isDealer){
          // 外部ユーザー
          this.$router.push({name: "CpapMenu"});
        }else{
          // 内部ユーザー
          this.$router.push({name: "cpapHome"});
        }
      }
    },
    doSearch: function() {
      if(!this.isHospital && !this.isDealer){
        let isSearchParam = false
        let keys = Object.keys(this.searchConditions)
        for(let i=0; i < keys.length; i++){
          if(this.searchConditions[keys[i]]+"" !="" && this.searchConditions[keys[i]] !="[]"){
            isSearchParam = true
            break;
          }
        }
        if(!isSearchParam){
          // 検索条件が１つも設定されていない場合
          this.showErrorMessage("検索条件が入力されていません。")
          return;
        }
      }

      var excuteApi = this.getCpapPatientListPOST;
      var successCallBack = this.getCpapPatientListPOSTSuccess;
      var errorCallBack = this.getCpapPatientListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapPatientListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      // obj.kind = obj.kind.length!=0 ? JSON.parse(obj.kind) : []
      // obj.progress = obj.progress.length!=0 ? JSON.parse(obj.progress) : []
      if(this.isHospital || this.isDealer){
        obj.belongsId = this.belongsId
      }
      if(!obj.progress){
        delete obj.progress
      }
      return client.apis.externalCpap.getCpapPatientListPOST({
        body:obj
      });
    },
    getCpapPatientListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data && this.data.length > 0){
         //指定件数を超えていた場合、メッセージ表示
        if(this.data[0].executeQueryLimitMessage) {
          this.showMessage(this.data[0].executeQueryLimitMessage)
        }
      }
      this.dataBlank = true;
    },
    getCpapPatientListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    progressCodeFilter(data){
      if(data.applicationType == 2 && data.status != 14 ){
        return "処方変更中"
      }
      if(data.applicationType == 5 && data.status != 14 ){
        return "処方再開中"
      }
      var target = this.progressList.find(val => val.code == data.progress)
      if(target){
        return target.name
      }
      return ""
    },
    isEscrowDeletion(){
      this.isEscrow = "";
    },
    getDate(){
      return this.yyyy_hyp_MM_hyp_dd(new Date());
    },
    getThreeMonthAgoDate() {
      let today = new Date();
      // 3か月前の日付を計算
      today.setMonth(today.getMonth() - 3);
      return this.yyyy_hyp_MM_hyp_dd(today);
    },
  },
  data() {
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = Number(userInfo.roleId);
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isAdmin = roleId == role.role_admin;
    var isHonsha = roleId == role.role_headOffice;
    var isSalesOffice = roleId == role.role_salesOffice;
    var branchList = this.getBranchOfficeMaster();
    var modelList = this.getCpapMaster();
    var progressList = this.getCpapManagementStatusList();
    var salesOfficeCode = ""
    var defaultDate = "";
    var defaultThreemonthAgoDate = "";
    if(isSalesOffice || isHonsha || isAdmin) {
      salesOfficeCode = userInfo.branchOfficeCode;
      defaultDate = this.getDate();
      defaultThreemonthAgoDate = this.getThreeMonthAgoDate();
    }
    let searchConditions = {
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      salesOfficeCode:salesOfficeCode,
      medicalInstitutionCode: "",
      medicalInstitutionName: "",
      serial:"",
      postCode:"",
      progress:"",
      instructionDateStart:defaultThreemonthAgoDate,
      instructionDateEnd:defaultDate,
      transferPeriodStart:"",
      transferPeriodEnd:"",
      patientRegistrationCard:""
    };
    // 預託判定
    let isEscrow = false;
    if(this.$route.params["isEscrow"]){
      isEscrow = this.$route.params["isEscrow"];
    };
    return {
      temp,
      takeOverSearchParams,
      searchConditions,
      data: [],
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      role: role,
      isPaginated : true,
      belongsId: (isHospital || isDealer) ? userInfo.belongsId : "",
      modelList,
      progressList,
      branchList,
      isEscrow,
      dataBlank: false
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.reportFormatType == val)
      if(target){
        return target.itemName
      }
      return ""
    },
    codeFilter(value,list){
      var target = list.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    }
  },
  components: {},
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapPatientList.vue